import React from 'react';
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import Blog from "./components/Blog";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const App = () => {
  React.useEffect(() => {
    // Progressive enhancement: reveal .reveal elements as they scroll into view.
    // Content is visible by default (see CSS); we only opt into the animation when
    // JS + IntersectionObserver + motion are all available.
    const mq = typeof window.matchMedia === 'function'
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;
    if ((mq && mq.matches) || typeof IntersectionObserver === 'undefined') return;

    const root = document.documentElement;
    root.classList.add('js-reveal');
    const els = Array.from(document.querySelectorAll('.reveal'));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach((el) => io.observe(el));

    return () => {
      io.disconnect();
      root.classList.remove('js-reveal');
    };
  }, []);

  return (
    <div className="site">
      <Header />
      <main>
        <Hero />
        <Skills />
        <Projects />
        <Experience />
        <Blog />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default React.memo(App);
